"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppRoutes = void 0;
const react_1 = __importStar(require("react"));
const Toast_1 = __importDefault(require("react-bootstrap/Toast"));
const react_router_dom_1 = require("react-router-dom");
const BookingPage_1 = require("../components/booking-page/BookingPage");
const HomePage_1 = require("../components/home-page/HomePage");
const ManagerPagePasswordReset_1 = require("../components/manager-page-password-reset/ManagerPagePasswordReset");
const ManagerPageSignIn_1 = require("../components/manager-page-sign-in/ManagerPageSignIn");
const ResourcePageBookingConfigurator_1 = require("../components/resource-page-booking-configurator/ResourcePageBookingConfigurator");
const ResourcePageOverview_1 = require("../components/resource-page-overview/ResourcePageOverview");
const authContext_1 = require("../context/authContext");
const configContext_1 = require("../context/configContext");
const environment_1 = require("../environment");
const ManagerRoutes_1 = require("./ManagerRoutes");
const AppRoutes = (props) => {
    const [showDevWarning, setShowDevWarning] = (0, react_1.useState)((0, environment_1.getEnv)().envName === "dev");
    // Add trailing slash to url if not present.
    const location = (0, react_router_dom_1.useLocation)();
    if (!location.pathname.endsWith("/")) {
        return (react_1.default.createElement(react_router_dom_1.Navigate, { to: {
                ...location,
                pathname: `${location.pathname}/`,
            }, replace: true }));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_router_dom_1.Routes, null,
            react_1.default.createElement(react_router_dom_1.Route, { path: "/", element: react_1.default.createElement(HomePage_1.HomePage, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "resources/:tenantId", element: react_1.default.createElement(configContext_1.ConfigProvider, null,
                    react_1.default.createElement(ResourcePageOverview_1.ResourcePageOverview, null)) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "resources/:tenantId/:resourceId", element: react_1.default.createElement(configContext_1.ConfigProvider, null,
                    react_1.default.createElement(ResourcePageBookingConfigurator_1.ResourcePageBookingConfigurator, null)) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "bookings/:bookingId", element: react_1.default.createElement(BookingPage_1.BookingPage, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "manager/*", element: react_1.default.createElement(authContext_1.AuthProvider, null,
                    react_1.default.createElement("div", { className: "manager-page" },
                        react_1.default.createElement(ManagerRoutes_1.ManagerRoutes, null))) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "manager/:tenantId/*", element: react_1.default.createElement(authContext_1.AuthProvider, null,
                    react_1.default.createElement("div", { className: "manager-page" },
                        react_1.default.createElement(ManagerRoutes_1.ManagerRoutes, null))) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "signin", element: react_1.default.createElement(authContext_1.AuthProvider, null,
                    react_1.default.createElement(ManagerPageSignIn_1.ManagerPageSignIn, null)) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "password-reset", element: react_1.default.createElement(authContext_1.AuthProvider, null,
                    react_1.default.createElement(ManagerPagePasswordReset_1.ManagerPagePasswordReset, null)) })),
        showDevWarning && (react_1.default.createElement(Toast_1.default, { onClose: () => setShowDevWarning(false), style: {
                position: "fixed",
                bottom: 20,
                right: 20,
                zIndex: 10000,
            } },
            react_1.default.createElement(Toast_1.default.Header, { className: "bg-warning text-dark" },
                react_1.default.createElement("strong", { className: "mr-auto" }, "Dev Environment!")),
            react_1.default.createElement(Toast_1.default.Body, null, "This is the development environment. Only use for testing.")))));
};
exports.AppRoutes = AppRoutes;
